import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TermsOfServicePage.css';

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="container">
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Back to Home
          </button>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: February 27, 2026</p>
        </div>
      </div>

      <div className="policy-content">
        <div className="container">
          <div className="policy-section">
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using the services provided by DT Consultancy, you agree to be bound by these Terms of Service 
              and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from 
              using or accessing our services.
            </p>
          </div>

          <div className="policy-section">
            <h2>2. Services Description</h2>
            <p>
              DT Consultancy provides technology consulting, software development, data engineering, AI solutions, 
              digital marketing, and design services. The specific scope, deliverables, and timelines for each 
              project will be outlined in separate service agreements or statements of work.
            </p>
          </div>

          <div className="policy-section">
            <h2>3. Use License</h2>
            <p>
              Permission is granted to temporarily access the materials on DT Consultancy's website for personal, 
              non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and 
              under this license you may not:
            </p>
            <ul>
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to decompile or reverse engineer any software contained on our website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
              <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>4. Client Responsibilities</h2>
            <p>When engaging our services, clients agree to:</p>
            <ul>
              <li>Provide accurate and complete information necessary for project completion</li>
              <li>Respond to requests for information and feedback in a timely manner</li>
              <li>Pay all fees according to the agreed payment terms</li>
              <li>Respect intellectual property rights and confidentiality obligations</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>5. Payment Terms</h2>
            <p>
              Payment terms will be specified in individual project agreements. Generally, clients agree to pay 
              all fees according to the payment schedule outlined in the service agreement. Late payments may 
              result in suspension of services and may incur late payment fees.
            </p>
          </div>

          <div className="policy-section">
            <h2>6. Intellectual Property Rights</h2>
            <p>
              Unless otherwise specified in a separate agreement:
            </p>
            <ul>
              <li>All pre-existing intellectual property remains the property of DT Consultancy</li>
              <li>Custom deliverables created specifically for a client project will be transferred to the client upon full payment</li>
              <li>DT Consultancy retains the right to showcase completed work in portfolios and marketing materials unless otherwise agreed</li>
              <li>Clients grant DT Consultancy a license to use their trademarks and materials solely for the purpose of providing services</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>7. Confidentiality</h2>
            <p>
              Both parties agree to maintain the confidentiality of any proprietary or sensitive information shared 
              during the course of the engagement. This obligation survives the termination of the service agreement.
            </p>
          </div>

          <div className="policy-section">
            <h2>8. Warranties and Disclaimers</h2>
            <p>
              We strive to provide high-quality services, but:
            </p>
            <ul>
              <li>Services are provided "as is" without warranties of any kind, either express or implied</li>
              <li>We do not guarantee uninterrupted or error-free service delivery</li>
              <li>We do not warrant that the results obtained from our services will meet your requirements</li>
              <li>Third-party services integrated into our solutions are subject to their own terms and warranties</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              In no event shall DT Consultancy or its suppliers be liable for any damages (including, without limitation, 
              damages for loss of data or profit, or due to business interruption) arising out of the use or inability to 
              use our services, even if we have been notified of the possibility of such damage.
            </p>
          </div>

          <div className="policy-section">
            <h2>10. Termination</h2>
            <p>
              Either party may terminate a service agreement according to the terms specified in that agreement. 
              Upon termination, clients remain responsible for payment of services rendered up to the termination date. 
              We reserve the right to terminate access to our website and services for violation of these terms.
            </p>
          </div>

          <div className="policy-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms of service at any time. Changes will be effective immediately 
              upon posting to our website. Your continued use of our services after changes are posted constitutes 
              acceptance of the modified terms.
            </p>
          </div>

          <div className="policy-section">
            <h2>12. Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of India, and you irrevocably 
              submit to the exclusive jurisdiction of the courts in that location.
            </p>
          </div>

          <div className="policy-section">
            <h2>13. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <ul>
              <li>By email: <a href="mailto:dt.consult.common@gmail.com">dt.consult.common@gmail.com</a></li>
              <li>By phone: <a href="tel:+918439533217">+91-8439533217</a></li>
              <li>By mail: D-9, Ground Floor, Sec-3, Noida, UP 201301, India</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
